export const baseFonts = {
  Franklin: '"FranklinGothicURWCon-Dem",serif',
  CentSchbook: '"CentSchbookBTWGL4WXX-Roman",serif',
};

export const fonts = {
  ...baseFonts,
  body: baseFonts.Franklin,
  heading: baseFonts.Franklin,
  paragraph: baseFonts.CentSchbook,
};
export const fontSizes = {
  xs: "0.6875rem",
  sm: "0.875rem",
  body: "1rem",
  md: "1.125rem",
  lg: "1.5rem",
  xl: "1.875rem",
  h1: "1.875rem",
  h2: "1.5rem",
  h3: "1.25rem",
  h4: "1rem",
  mega: "2.625rem",
};
export const baseFontWeights = {
  thin: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const fontWeights = {
  ...baseFontWeights,
  body: baseFontWeights.medium,
  heading: baseFontWeights.medium,
};
